/**
 * Decorate a function with error handling
 */
export const withErrorHandling =
  (onError: (e: unknown) => void, fn: (...args: any) => any) => () => {
    try {
      return fn()?.catch(onError);
    } catch (e) {
      onError(e);
    }
  };
